import React, { useState } from "react"
import { Link } from "react-router-dom"
import "./header.css"

const Header = () => {
  const [click, setClick] = useState(false)

  return (
    <>
      
      <header>
        <nav className='flexSB'>
          <ul className={click ? "mobile-nav" : "flexSB "} onClick={() => setClick(false)}>
            <li>
              <Link to='/'>Home</Link>
            </li>
            <li>
              <Link to='/beneflex'>Beneflex</Link>
            </li>
            <li>
              <Link to='/finanzas'>Finanzas</Link>
            </li>
            <li>
              <Link to='/curso-de-ingles'>Cursos de Ingles</Link>
            </li>
            <li>
              <Link to='/curso-de-naturalizacion'>Naturalización</Link>
            </li>
            <li>
              <Link to='/ozias'>Ozias</Link>
            </li>
            <li>
              <Link to='/referencias'>Referencias</Link>
            </li>
          </ul>
          <div className='start'>
            <div className='button'>623 230-3656</div>
          </div>
          <button className='toggle' onClick={() => setClick(!click)}>
            {click ? <i className='fa fa-times'> </i> : <i className='fa fa-bars'></i>}
          </button>
        </nav>
      </header>
    </>
  )
}

export default Header